var React = require('react');

function ChatCloudLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M445.139 2.98428C478.704 2.98428 504 27.4067 504 61.8901V107.84C504 137.805 480.581 166.84 445.139 166.84H434.887C425.679 166.84 412.979 172.132 406.504 178.696L341.574 244.543C335.098 251.108 328.457 249.062 326.704 240.013L315.829 183.226C314.077 174.177 306.34 166.84 298.561 166.84H61.8613C25.6058 166.84 3.00001 140.539 3.00001 107.84V61.8901C3.00001 26.426 27.3992 2.98428 61.8613 2.98428H445.139Z","stroke":"white","strokeWidth":"5"}));
}

ChatCloudLeftInline.defaultProps = {"width":"507","height":"251","viewBox":"0 0 507 251","fill":"none"};

module.exports = ChatCloudLeftInline;

ChatCloudLeftInline.default = ChatCloudLeftInline;
